import ko from "knockout";
import _ from "lodash";
import ObservableModel from "util/ObservableModel";

export default ObservableModel.extend(
    {
        modelProperties: {
            expansionCriteria: ObservableModel.extend({
                // expansionCriteria is an array
                defaults: {
                    type: "TIMEOUT_SECONDS",
                    threshold: null,
                },
            }),
            actions: ObservableModel.extend({
                // actions is an object
                modelProperties: {
                    skillsToRemove: ObservableModel.extend({
                        // skillsToRemove is an array
                        defaults: {
                            id: null,
                            name: null,
                            selfUri: null,
                        },
                    }),
                },
            }),
        },
        defaults: {
            id: null,
            actions: {
                skillsToRemove: [],
            },
            expansionCriteria: [
                {
                    threshold: 0,
                },
            ],
        },
    },
    function () {
        const self = this;

        ko.computed(function () {
            _.each(self.expansionCriteria(), function (obj) {
                obj.threshold.extend({
                    numeric: { precision: 0, min: 0, max: 900 },
                });
            });
        });

        self.unwrap = function () {
            return ObservableModel.unwrap(self, [
                "errors",
                "isAnyMessageShown",
                "isValid",
                "unwrap",
            ]);
        };
    }
);
